import { render, staticRenderFns } from "./listaCupones.vue?vue&type=template&id=079202af&scoped=true"
import script from "./listaCupones.vue?vue&type=script&lang=js"
export * from "./listaCupones.vue?vue&type=script&lang=js"
import style0 from "./listaCupones.vue?vue&type=style&index=0&id=079202af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079202af",
  null
  
)

export default component.exports